import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import reportWebVitals from './reportWebVitals';

// Bootstrap CSS
import "bootstrap/dist/css/bootstrap.min.css";
// Bootstrap Bundle JS
import "bootstrap/dist/js/bootstrap.bundle.min";
// Bootstrap Icons
import "bootstrap-icons/font/bootstrap-icons.css";
// Custom Icons
import './index.scss';
// Shepherd.js CSS
import 'shepherd.js/dist/css/shepherd.css';
// // Driver JS for tour
// import "driver.js/dist/driver.css";
// React-DatePicker CSS
import "react-datepicker/dist/react-datepicker.css";
// HighCharts Accessibility
import HighCharts from "highcharts";
import accessibility from "highcharts/modules/accessibility.js";
accessibility(HighCharts);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
